import { defaultClassNames } from "./classNames.default";
export const whitelabelCustomClassNames = {
    ...defaultClassNames,
    pager: {
        navigationButton: 'button button--primary button--arrow'
    }
};
